<template>
    <div :id="`${baseId}`">
        <v-layout class="rewards_quick_overview" :id="`${baseId}-quick-overview`">
            <div class="rewards-entries" :id="`${baseId}-quick-overview-entries-container`">
                <span class="p-small pad-values-right rewards-label tx-font-primary" :id="`${baseId}-quick-overview-entries-text`"
                >{{ $nsLanguage.getTranslation('entries') }}:</span>
                <br class="rewards-line-break" :id="`${baseId}-quick-overview-entries-line-break`"/>
                <span class="rewards-value tx-font-primary" :id="`${baseId}-quick-overview-entries-value`">{{ rewardsHistoryNumber }}</span>
            </div>
            <div class="rewards-total" :id="`${baseId}-quick-overview-rewards-container`">
                <span class="p-small rewards-label" :id="`${baseId}-quick-overview-rewards-text`">{{ $nsLanguage.getTranslation('total_savings') }}:</span>
                <br class="rewards-line-break" :id="`${baseId}-quick-overview-rewards-line-break`" />
                <span class="rewards-value pad-values-left tx-font-primary" :id="`${baseId}-quick-overview-rewards-value`"
                >{{ getCurrency(lifetimeSpend) }} {{ $nsLanguage.getTranslation('rewardsHistory.totals.enjoyCreditsLabel') }}</span>
            </div>
        </v-layout>
        <v-layout class="rewards_history" :id="`${baseId}-rewards-history-section`">
            <v-flex class="bs">
                <b-table
                    striped
                    borderless
                    :hover=false
                    :per-page="rewardsHistoryPagination"
                    :current-page="rewardsHistoryCurrentPage"
                    :items="rewardsHistory"
                    :fields="rewardsHistoryFields"
                    table-class="rewards_history_table tx-font-primary"
                    thead-class="rewards_history_table_header tx-font-primary"
                    tbody-class="rewards_history_table_body"
                    id="history_table">
                </b-table>
                <b-pagination
                    v-model="rewardsHistoryCurrentPage"
                    :total-rows="rewardsHistoryNumber"
                    :per-page="rewardsHistoryPagination"
                    aria-controls="history_table"
                    hide-goto-end-buttons
                    align="right"
                    small
                    @change="changePage()">
                </b-pagination>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>

import moment from 'moment'
import { formatPoints } from '../services/points'
import { events } from '@nuskin/ns-util'

export default {
    name: 'RewardsHistory',
    props: {
        context: {
            type: String,
            required: true
        },
        creditsHistory: {
            type: Array,
            default: function () { return [] }
        },
        lifetimeSpend: {
            type: Number,
            default: 0
        },
        narrowView: {
            type: Boolean,
            default: false
        },
        parentId: {
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            rewardsHistoryFields: [],
            rewardsHistory: [],
            rewardsHistoryNumber: 0,
            rewardsHistoryPagination: 10,
            rewardsHistoryCurrentPage: 1
        }
    },
    computed: {
        baseId: function () {
            const defaultBase = 'rewards-history'
            if (this.parentId) {
                return `${this.parentId}-${defaultBase}`
            } else {
                return defaultBase
            }
        }
    },
    methods: {
        changePage () {
            events.tag(events.loyalty.LOYALTY_REWARDS_PAGE_CHANGE, { context: this.context })
        },
        getCurrency: function (value) {
            return formatPoints(value)
        },
        getRewardsHistoryTable: function () {
            this.rewardsHistory = []
            this.creditsHistory.forEach((activity) => {
                const activityDate = new Date(activity.createDate)
                const newActivity = {
                    date: this.returnMomentFormat(activityDate, 'MM/DD/YYYY'),
                    action: this.$nsLanguage.getTranslation(activity.displayText),
                    credits: activity.credit ? '+ ' + this.getCurrency(activity.credit) : '- (' + this.getCurrency(activity.debit) + ')',
                    expires: activity.expireDate ? this.returnMomentFormat(new Date(activity.expireDate), 'MM/DD/YYYY') : '--'
                }

                this.rewardsHistory.push(newActivity)
            })

            this.rewardsHistoryNumber = this.rewardsHistory.length

            var windowWidth = window.innerWidth
            if (windowWidth < 600 || this.narrowView) {
                this.rewardsHistoryFields = [
                    {
                        key: 'action',
                        label: this.$nsLanguage.getTranslation('action'),
                        tdClass: 'left_align_column',
                        thClass: 'left_align_column'
                    },
                    {
                        key: 'credits',
                        label: this.$nsLanguage.getTranslation('rewardsHistory.tableHeader.enjoyCreditsLabel'),
                        tdClass: 'right_align_column bold_column_content',
                        thClass: 'right_align_column text-transform-normal'
                    },
                    {
                        key: 'expires',
                        label: this.$nsLanguage.getTranslation('expires'),
                        tdClass: 'right_align_column',
                        thClass: 'right_align_column'
                    }

                ]
            } else {
                this.rewardsHistoryFields = [
                    {
                        key: 'date',
                        label: this.$nsLanguage.getTranslation('date'),
                        tdClass: 'left_align_column',
                        thClass: 'left_align_column'
                    },
                    {
                        key: 'action',
                        label: this.$nsLanguage.getTranslation('action'),
                        tdClass: 'left_align_column',
                        thClass: 'left_align_column'
                    },
                    {
                        key: 'credits',
                        label: this.$nsLanguage.getTranslation('rewardsHistory.tableHeader.enjoyCreditsLabel'),
                        tdClass: 'right_align_column bold_column_content',
                        thClass: 'right_align_column text-transform-normal'
                    },
                    {
                        key: 'expires',
                        label: this.$nsLanguage.getTranslation('expires'),
                        tdClass: 'right_align_column',
                        thClass: 'right_align_column'
                    }
                ]
            }
        },
        returnMomentFormat: function (dateObj, format) {
            return moment(dateObj).format(format)
        }
    },
    mounted () {
        this.getRewardsHistoryTable()
        window.addEventListener('resize', this.getRewardsHistoryTable)
    },
    watch: {
        creditsHistory (newHistory) {
            this.getRewardsHistoryTable()
        }
    }
}
</script>

<style scoped lang="scss">

    $color-gray-114: rgb(114, 114, 114);

    $page-width-small: 600px;

    .rewards_quick_overview {
        justify-content: space-between;
        margin-top: 40px;
        text-transform: uppercase;
    }

    .rewards-entries,
    .rewards-total {
        display: inline-block;
        white-space: nowrap;
    }

    .rewards-entries {
        text-align: left;
    }

    .rewards-total {
        text-align: right;
    }

    .rewards-line-break {
        display: none;
    }

    .rewards-label {
        color: $color-gray-114;
    }

    .rewards-value {
        font-weight: 700;
    }

    .pad-values-left {
        padding-left: 0.50em;
    }

    .pad-values-right {
        padding-right: 0.50em;
    }

    // View - Small
    @media screen and (max-width: $page-width-small) {
        .rewards-line-break {
            display: initial;
        }
    }

    .rewards_history_table {
        color: #727272;
        font-size: 13px;
        text-transform: capitalize;
        border-bottom: solid thin #d1d1d1;
    }

    .rewards_history_table_header {
        color: #444444;
        font-size: 13px;
        border-bottom: solid 1px  #d1d1d1;
    }
</style>

<style lang="scss">
    .rewards_history_table {
        .rewards_history_table_body {
            border-top: double #d1d1d1 4px;
            font-size: 14px;
        }
    }

    .left_align_column {
        text-align: left !important;
    }

    .right_align_column {
        text-align: right !important;
    }

    .text-transform-normal {
        text-transform: none !important;
    }

    .bold_column_content{
        font-weight: 700;
    }

    .page-item:first-child.disabled,
    .page-item:last-child.disabled {
        opacity: 0.50;
    }

    .page-item:first-child .page-link,
    .page-item:last-child .page-link {
        margin-top: -2px;
        font-size: 28px;
    }

    .page-item:first-child .page-link {
        border-color: transparent;
        border-radius: 0 !important;
    }
    .page-item:last-child .page-link {
        border-radius: 0 !important;
    }
    .page-item .page-link {
        color: rgba(0, 0, 0, 0.85) !important;
    }
    .page-item.active .page-link{
        background-color: #272525 !important;
        color: #fff !important;
    }
    .bs .page-link {
        border: none !important;
    }

    .bs .pagination {
        .page-link {
            width: 24px !important;
            height: 24px !important;
            line-height: 24px !important;
            padding: 0 !important;
        }
    }

    .page-link:hover{
        text-decoration: underline;
    }
    .page-link:focus {
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
    }
    .bs .table-striped tbody tr:nth-of-type(2n+1) {
        background-color: #f7f7f7;
    }
</style>
